import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles((theme) => ({
  card: {
    borderTop: `4px solid transparent`,
  },
}));

export default styles;
